import { useMemo } from 'react';
import { COMBO_BOX_OPTIONS_3 } from '../combobox-popovers/all-filters-combobox-popover';
import DeliveryDateFiltersComboBoxPopover from '../combobox-popovers/delivery-date-filters-combobox-popover';
import {
  DELIVERY_DATE_FILTER_OPTIONS,
  type DeliveryDateFilterChipProps,
  type DeliveryDateFiltersState,
} from '../types';
import BaseDateFilterChip from './base-date-filter-chip';

const DeliveryDateFilterChip = (props: DeliveryDateFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  const selectedOption = useMemo(() => {
    return DELIVERY_DATE_FILTER_OPTIONS.find(
      (option) => option.value === filtersState.selectedFilters,
    );
  }, [filtersState.selectedFilters]);

  const useBeforeAfterCopy = useMemo(() => {
    return selectedOption?.value !== 'in-the-past';
  }, [JSON.stringify(selectedOption)]);

  return (
    // TODO: fix the type
    <BaseDateFilterChip<DeliveryDateFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={DeliveryDateFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_3.find((option) => option.value === 'delivery_date')
          ?.icon
      }
      filterName="Delivery date"
      filterQuantifier={{
        singular: selectedOption?.label || '',
        plural: selectedOption?.label || '',
      }}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      useBeforeAfterCopy={useBeforeAfterCopy}
    />
  );
};

export default DeliveryDateFilterChip;
